import { render, staticRenderFns } from "./NeedView.vue?vue&type=template&id=3f03cf4e"
import script from "./NeedView.vue?vue&type=script&lang=js"
export * from "./NeedView.vue?vue&type=script&lang=js"
import style0 from "./NeedView.vue?vue&type=style&index=0&id=3f03cf4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports